import React from 'react';
import PropTypes from 'prop-types';

const DayBlock = props => {
  return (
    <div className="is-flex">
      <div
        style={{
          borderRight: '1px solid rgba(19, 25, 37, 0.3)',
          borderBottom: '1px solid rgba(19, 25, 37, 0.3)',
          padding: '5px',
          width: '16%',
        }}
      >
        {props.day}
      </div>
      <div
        style={{ borderBottom: '1px solid rgba(19, 25, 37, 0.3)', width: '84%', padding: '5px', position: 'relative' }}
      >
        {props.times.map((time, timeIndex) => (
          <div
            key={timeIndex}
            className="timetable-time"
            style={{ left: `${20 + 50 * timeIndex}px`, top: '30%', width: '100%' }}
          >
            <div className="is-flex align-items-center">
              <div className="timetable-circle"></div>
              <span className="ml-5px">{time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

DayBlock.propTypes = {
  day: PropTypes.string.isRequired,
  times: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const TimetableBlockMobile = props => {
  return (
    <div className="m-webinar-block">
      <div className="m-webinar-block-header">
        <div className="is-flex align-items-center">
          <img src="img/icons/timetable.svg" />
          <p className="ml-10px">My timetable</p>
        </div>
      </div>
      <div className="m-webinar-block-content">
        {/* <p className="m-timetable-block-text">The next lesson:</p>
        <p className="m-timetable-block-date">Date is undefined</p> */}

        <div className="mt-15px">
          {props.timetable.map(x => (
            <DayBlock key={x.month} day={x.month} times={x.times} />
          ))}
        </div>
      </div>
    </div>
  );
};

TimetableBlockMobile.propTypes = {
  timetable: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      times: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
};

export default TimetableBlockMobile;
